import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { DEBT_USER_TYPE } from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import { ICreateAndUpdateSuperAgent } from "../../../../../../types/superAgent.interface";
import values from "../../../../../../values";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import CustomDropDownSearch from "../../../../../../components/CustomDropDownSearch";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

const Filter = () => {
  const { requestDebt, setRequestDebt } = useContext(Context.DebtsScreen);
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const [selectedType, setSelectedType] = useState<IItem | null>();

  // !! ===========================================================================================================
  // !!                                            superAgent
  // !! -----------------------------------------------------------------------------------------------------------

  const [selectedSuperAgent, setSelectedSuperAgent] =
    useState<ICreateAndUpdateSuperAgent | null>();
  const [superAgentSearchedValue, setSuperAgentSearchedValue] =
    React.useState<IOnSearchUser>();

  const getAllSuperAgent = useQuery(
    [values.useQueryKeys.getAllSuperAgent, superAgentSearchedValue],
    () =>
      api.post.administrator.getAllSuperAgent({
        search: {
          base: superAgentSearchedValue?.base.value,
          value: superAgentSearchedValue?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const AllSuperAgentWithCompleteName = getAllSuperAgent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            company
  // !! -----------------------------------------------------------------------------------------------------------
  const [searchedValueCompany, setSearchedValueCompany] =
    React.useState<IOnSearchUser>();
  const [selectedCompany, setSelectedCompany] = useState<any>();

  const getAllCompanyAdmin = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.administrator.getAllCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllCompanyCommon = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.superAgent.findCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" && userType !== "COMPANY" }
  );

  const getAllCompany =
    userType === "ADMIN" ? getAllCompanyAdmin : getAllCompanyCommon;

  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  // !! ===========================================================================================================
  // !!                                            driver
  // !! -----------------------------------------------------------------------------------------------------------
  const [searchedValueDriver, setSearchedValueDriver] =
    React.useState<IOnSearchUser>();
  const [selectedDriver, setSelectedDriver] = useState<any>();

  const getAllDriverAdmin = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.common.findDriver({
        companyId: selectedCompany?._id,
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );

  const getAllDriverCommon = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.superAgent.findDriver({
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      }),
    { enabled: userType !== "ADMIN" }
  );

  const getAllDriver =
    userType === "ADMIN" ? getAllDriverAdmin : getAllDriverCommon;

  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item?.firstName + " " + item?.lastName,
      };
    }
  );

  // !! ===========================================================================================================
  // !!                                            driver
  // !! -----------------------------------------------------------------------------------------------------------
  // const [searchedValueStudent, setSearchedValueStudent] =
  //   useState<IOnSearchUser>();
  // const [selectedStudent, setSelectedStudent] = useState<any>();

  // const getAllStudent = useQuery(
  //   [values.useQueryKeys.getAllService, searchedValueStudent?.searchedValue],
  //   () =>
  //     api.post.common.findService({
  //       search: {
  //         base: searchedValueStudent?.base?.value?.split(".")[1],
  //         value: searchedValueStudent?.searchedValue,
  //       },
  //     })
  // );

  // const AllStudentWithCompleteName = getAllStudent?.data?.result?.map(
  //   (item: any) => {
  //     return {
  //       ...item,
  //       completeName: item.firstName + " " + item.lastName,
  //     };
  //   }
  // );

  // !! ===========================================================================================================
  // !!                                            province & city
  // !! -----------------------------------------------------------------------------------------------------------

  const [selectedCity, setSelectedCity] = useState<any>();
  const [selectedProvince, setSelectedProvince] = useState<any>();

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () =>
      api.get.common.getAllCity({
        provinceCode: selectedProvince?.ProvinceCode,
      })
  );

  const { t } = useTranslation();

  return (
    <div className="filter-container">
      <CustomDropdownFilter
        title={t("filter")}
        hoverTitle={t("filter")}
        min_width="30vw"
      >
        <CustomView.Row>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("userType")}</label>
            <CustomDropdownSearch
              items={DEBT_USER_TYPE}
              itemName="name"
              defaultItem={selectedType}
              onSelectItem={(event: IItem) => {
                setSelectedType(event);
                setRequestDebt({
                  ...requestDebt,
                  filters: {
                    ...requestDebt?.filters,
                    type: event?._id,
                  },
                });
              }}
              placeHolder={t("selectUserType")}
              isLoading={getAllSuperAgent.isLoading}
            />
          </CustomView.Column>
          {userType === "ADMIN" && (
            <CustomView.Column medium={6}>
              <label className="form-label">{t("municipality")}</label>
              <CustomDropdownMultiSearch
                isSearch
                items={AllSuperAgentWithCompleteName}
                itemName="completeName"
                defaultItem={selectedSuperAgent}
                onSelectItem={(event: ICreateAndUpdateSuperAgent) => {
                  setSelectedSuperAgent(event);
                  setRequestDebt({
                    ...requestDebt,
                    filters: {
                      ...requestDebt?.filters,
                      superAgent: event?._id,
                    },
                  });
                }}
                placeHolder={t("selectMunicipality")}
                baseSearch={values.dropdownBaseSearch.SUPER_AGENT_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                setSearchedValue={setSuperAgentSearchedValue}
                searchedValue={superAgentSearchedValue}
                isLoading={getAllSuperAgent.isLoading}
                selectedBaseSearch={superAgentSearchedValue?.base?.value}
              />
            </CustomView.Column>
          )}

          {/* <CustomView.Column medium={6}>
            <label className="form-label">دانش آموز</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SERVICE_BASE_SEARCH}
              items={AllStudentWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: any) => {
                setSelectedStudent(event);
                setRequestDebt({
                  ...requestDebt,
                  filters: {
                    ...requestDebt.filters,
                    student: event,
                  },
                });
              }}
              defaultItem={selectedStudent}
              searchedValue={searchedValueStudent}
              setSearchedValue={setSearchedValueStudent}
              placeHolder="انتخاب دانش آموز"
              isLoading={getAllStudent.isLoading}
              selectedBaseSearch={searchedValueStudent?.base?.value}
            />
          </CustomView.Column> */}
          {userType !== "COMPANY" && (
            <CustomView.Column medium={6}>
              <label className="form-label">{t("company")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                items={companyInformationWithCompanyName}
                itemName="companyName"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedCompany(event);
                  setRequestDebt({
                    ...requestDebt,
                    filters: {
                      ...requestDebt?.filters,
                      company: event?._id,
                    },
                  });
                }}
                defaultItem={selectedCompany}
                searchedValue={searchedValueCompany}
                setSearchedValue={setSearchedValueCompany}
                placeHolder={t("selectCompany")}
                isLoading={getAllCompany.isLoading}
                selectedBaseSearch={
                  searchedValueCompany?.base?.value === "nationalCode"
                    ? "companyInformation.nationalCode"
                    : searchedValueCompany?.base?.value
                }
              />
            </CustomView.Column>
          )}
          <CustomView.Column medium={6}>
            <label className="form-label">{t("driver")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.DRIVER_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={AllDriverWithCompleteName}
              itemName="completeName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedDriver(event);
                setRequestDebt({
                  ...requestDebt,
                  filters: {
                    ...requestDebt?.filters,
                    driver: event?._id,
                  },
                });
              }}
              defaultItem={selectedDriver}
              searchedValue={searchedValueDriver}
              setSearchedValue={setSearchedValueDriver}
              placeHolder={t("selectDriver")}
              isLoading={getAllDriver.isLoading}
              selectedBaseSearch={searchedValueDriver?.base?.value}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label"> {t("province")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              onSelectItem={(event: IProvinceItem) => {
                setSelectedProvince(event);
                setSelectedCity(undefined);
                setRequestDebt({
                  ...requestDebt,
                  filters: {
                    ...requestDebt?.filters,
                    province: event?._id,
                  },
                });
              }}
              placeHolder={t("selectProvince")}
              defaultItem={selectedProvince}
              isLoading={getAllProvince.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <label className="form-label">{t("city")}</label>
            <CustomDropDownSearch
              isSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              onSelectItem={(event: ICityItem) => {
                setSelectedCity(event);
                setRequestDebt({
                  ...requestDebt,
                  filters: {
                    ...requestDebt?.filters,
                    city: event?._id,
                  },
                });
              }}
              placeHolder={t("selectCity")}
              defaultItem={selectedCity}
              isLoading={getAllCity.isLoading}
            />
          </CustomView.Column>
        </CustomView.Row>

        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestDebt({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
              setSelectedCity(null);
              setSelectedCompany(null);
              setSelectedDriver(null);
              setSelectedProvince(null);
              setSelectedSuperAgent(null);
              setSelectedType(null);
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );
};

export default Filter;
